export enum CurriculumEvents {
  /** User chose a grade on the bootcamp / onboarding grade grid (navigates into that grade) */
  GRADE_SELECTED = 'grade_selected',

  /** User moved to the previous or next grade from the in-page grade footer */
  ADJACENT_GRADE_NAVIGATED = 'adjacent_grade_navigated',
  CURRICULUM_LEVEL_OPENED = 'curriculum_level_opened',
  CURRICULUM_COUNTRY_SELECTOR_TOGGLED = 'curriculum_country_selector_toggled',
  CURRICULUM_COUNTRY_SELECTED = 'curriculum_country_selected',

  /** User chose to take the mapping quiz from the grade-overview modal */
  MAPPING_QUIZ_STARTED = 'mapping_quiz_started',
  /** User tapped a subtopic entry point on grade overview (may open mapping quiz modal or navigate) */
  SUBTOPIC_STARTED = 'subtopic_started',
  TOPIC_INTRO_MODAL_CLOSED = 'topic_intro_modal_closed',
  MAPPING_QUIZ_MODAL_CLOSED = 'mapping_quiz_modal_closed',
  MAPPING_QUIZ_ENTRY_CARD_CLICKED = 'mapping_quiz_entry_card_clicked',
  /** User tapped a topic card in the grade-overview sidebar (mobile collapse vs topic selection) */
  TOPIC_CARD_SELECTED = 'topic_card_selected',
  /** User advanced to the next level on the subtopic mastery track */
  CURRICULUM_LEVEL_ADVANCED = 'curriculum_level_advanced',

  /** User confirmed the v1→v2 migration via the system update modal CTA */
  SYSTEM_UPDATE_CONFIRMED = 'system_update_confirmed',
}
